// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// constants
import { apiRouter } from "@cloudspire/legacy-shared/src/constants/router";

// normalizers
import { commentParseSearch } from "../normalizers/comment";

export function commentsRoomPage({ roomReference, query }) {
  return {
    key: generateUri({
      router: apiRouter,
      name: "Api.Comments",
      query: {
        context: "front",
        ...query,
        roomRef: roomReference,
      },
    }),
    normalizer: commentParseSearch,
  };
}
